module.exports = __webpack_public_path__ + "static/media/payment-arrow.f082d388.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onBoardingArrows/payment-arrow.svg
// module id = 926
// module chunks = 21